<div class="popup-full-screen-wrapper" [ngClass]="(isVisible?'animate-up ':'animate-down ')">
    <ng-content></ng-content>
</div>
